import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import {
  registersQueryKeys,
  RequestTypes,
} from '@core/react-query/features/registers/registers'
import { RegistersLinkableItem } from '@core/entities/register/RegistersLinkableItem'
import {
  IRegistersLinkable,
  RegistersLinkable,
} from '@core/entities/register/RegistersLinkable'

const dataTransformer = (response: IRegistersLinkable[]) => {
  return response.map((item) => ({
    ...item,
    parentRegisters: item.parentRegisters.map((parentRegister) =>
      RegistersLinkableItem.new(parentRegister),
    ),
  }))
}

export const useGetRegistersLinkable = (
  payload: RequestTypes['getRegistersLinkable'],
  options?: UseQueryOptions<IRegistersLinkable[], string, RegistersLinkable[]>,
) => {
  return useQuery({
    ...registersQueryKeys.linkableRegisters(payload),
    select: dataTransformer,
    enabled: !!payload?.projectId && !!payload?.filter,
    ...options,
  })
}
